import { JsonDecoder } from 'ts.data.json';
import { SponsorMessage } from './model';

export const sponsorMessageDecoder = JsonDecoder.object<SponsorMessage>(
    {
        id: JsonDecoder.number,
        title: JsonDecoder.optional(JsonDecoder.string),
        textHTML: JsonDecoder.string
    },
    'SponsorMessage'
);

export const sponsorMessagesDecoder = JsonDecoder.array<SponsorMessage>(
    sponsorMessageDecoder,
    'SponsorMessage[]'
);
